export default __webpack_public_path__ + "static/media/proj3mov.3b152b6e.mp4";